<template>
    <div ref="modal" class="modal fade" :class="{ show: active, 'd-block': active }" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Customer: {{ data.customer_name }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" v-on:click="$emit('closeModal')"
                        aria-label="btn-close"></button>
                </div>

                <form ref="formElement" class="forms-sample" method="POST" @submit.prevent="submitData">
                    <div class="modal-body">

                        <div class="row mb-3">
                            <div class="col-md-3">
                                <label class="form-label mt-2">Billable Method </label>
                            </div>

                            <div class="col-md-4">
                                <multiselect  @search-change="asyncSearchBillabel" v-model="billableMethode" :show-labels="false" :options="fetchBillabel"
                                    placeholder="Search " label="tariff_name" track-by="tariff_name"></multiselect>
                            </div>


                        </div>


                        <div class="row mb-3">
                            <div class="col-md-3">
                                <label class="form-label mt-2">Periode</label>
                            </div>

                            <div class="col-md-4">
                                <Datepicker v-model="periode" :bootstrap-styling="true" format="MM-yyyy"
                                    placeholder="Please Select Date..."></Datepicker>
                                <!-- <input id="periode" type="month" v-model="periode"
                                    placeholder="Pilih Bulan dan Tahun" /> -->


                            </div>


                        </div>


                        <div class="row mb-3">
                            <div class="col-md-3">
                                <label class="form-label mt-2">SKU</label>
                            </div>

                            <div class="col-md-4">
                                <multiselect @search-change="asyncSearchSKU"  v-model="sku" :show-labels="false" :options="fetchSKU"
                                    @input="changeGetBil" placeholder="Search " label="sku_code" track-by="sku_code">
                                </multiselect>
                            </div>


                        </div>


                        <div class="row mb-3">
                            <div class="col-md-3">
                                <label class="form-label mt-2">Max Trip</label>
                            </div>

                            <div class="col-md-4">
                                <input v-model="max_trip" type="number" class="form-control" />
                            </div>


                        </div>


                        <div class="row mb-3">
                            <div class="col-md-3">
                                <label class="form-label mt-2">Rate</label>
                            </div>


                            <div class="col-md-4">
                                <CurrencyInput v-model.number="contract_rate" :options="{ currency: 'IDR' }"
                                    class="form-control" />
                                <!-- <input v-model="contract_rate" type="number" class="form-control" /> -->
                            </div>


                        </div>



                        <!--end::loading-data-->
                        <!-- <h5>{{ $t("areYouSure") }}</h5> -->



                        <div class="row mb-3">
                            <div class="col-md-3">
                                <label class="form-label mt-2">Jumlah Truck</label>
                            </div>

                            <div class="col-md-4">
                                <!-- <multiselect :multiple="true" @search-change="asyncSearchTruck" v-model="truck"
                                    :show-labels="false" :options="fetchTruck" placeholder="Search " label="name"
                                    track-by="name">
                                </multiselect> -->
                                <!-- <input v-model="jumlahTruck" type="number" class="form-control" /> -->


                            </div>

                            <!-- <div class="col-md-3 mt-2">
                                <span class="ms-2 text-muted" v-if="truck.length > 0">
                                    <b>{{ truck.length }}</b>
                                </span>
                            </div> -->


                        </div>

                        <div class="row">

                            <!-- Tabel Input -->
                            <div class="row mb-3">
                                <div class="col-md-6">
                                    <!-- Kosong atau isi apa aja -->
                                </div>

                                <div class="col-md-6 text-end">
                                    <span @click="addRow" class="btn btn-success btn-sm"
                                        style="margin-bottom: 10px; padding: 5px 10px; font-size: 14px;">
                                        Add
                                    </span>
                                </div>
                            </div>



                            <table cellpadding="10">
                                <thead style="background-color: #ccc;">
                                    <tr>
                                        <th>Truck No</th>
                                        <th>Vehicle No</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(row, index) in vehicle_no_array" :key="index">
                                        <td>
                                            {{ row.truck_no }}

                                        </td>
                                        <td>
                                            <!-- <input type="text" class="form-control" v-model="row.vehicle_no"
                                                placeholder="Enter Vehicle No" /> -->


                                            <multiselect v-model="row.vehicle"
                                                @search-change="onSearchChangeTruckVehicleNo"
                                                :options="fetchTruckVehicleNo" :preserve-search="true"
                                                placeholder="Vehicle No" label="vehicle_no" track-by="vehicle_no"
                                                :preselect-first="true">

                                            </multiselect>

                                            <!-- <multiselect v-model="row.vehicle_no" :show-labels="false"
                                                :options="fetchTruckVehicleNo" placeholder="Search " label="vehicle_no"
                                                track-by="vehicle_no"></multiselect> -->


                                        </td>
                                        <td>
                                            <span class="btn btn-danger" @click="removeRow(index)">Hapus</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>







                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" v-on:click="$emit('closeModal')">
                            No
                        </button>

                        <div v-if="isLoading" class="d-flex align-items-center">
                            <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                            <strong>Loading...</strong>
                        </div>

                        <button v-if="!isLoading" class="btn btn-primary" type="submit">Yes </button>

                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import multiselect from "vue-multiselect";
import Datepicker from "vuejs-datepicker";
import CurrencyInput from '@/components/_partials/inputCurrency.vue';

export default {

    components: {
        "multiselect": multiselect,
        Datepicker,
        CurrencyInput
    },
    name: "ModalFormDetailLumpsum",
    emits: ["closeModal"],

    props: {
        showModal: Boolean,
        data: null,
    },
    watch: {
        showModal: {

            handler(newVal) {
                console.log(this.data);
                // if (this.data != '') {


                //   // const startDate = this.data.delivery_date;
                //   // const endDate = new Date();

                //   // const startDate2 = this.data.return_date;
                //   // const endDate2 = new Date();

                //   this.forms = 
                //   {
                //       assign_driver  : '',
                //       assign_name_driver  : '',
                //       assign_date  :'',
                //       remarks_close  : ''
                //   }




                // } else {

                //   //const startDate = new Date();
                //   //const endDate = new Date();
                //   this.forms = {
                //       assign_driver  : '',
                //       assign_name_driver  : '',
                //       assign_date  :'',
                //       remarks_close  : ''
                //   };


                // }

                // this.forms = {
                //     assign_driver: '',
                //     assign_name_driver: '',
                //     assign_date: '',
                //     remarks_close: ''
                // };


                if (newVal) {
                    this.resetForm(); // <-- Tambahkan ini
                    this.loadBillabel();
                    this.loadSKU();
                    this.loadTruckVehicleNo();
                }

                this.active = newVal;
                const body = document.querySelector("body");
                this.showModal
                    ? body.classList.add("modal-open")
                    : body.classList.remove("modal-open");

                // this.loadBillabel(this.data.customer_code);
                // this.loadSKU(this.data.customer_name);
                // this.loadTruckVehicleNo();


            },
            immediate: true,
            deep: true,
        },
    },
    data() {
        return {
            vehicle_no_array: [
                { truck_no: 1, vehicle: '' }
            ],
            fetchTruckVehicleNo: [],
            periode: "",
            billableMethode: "",
            fetchBillabel: [],
            truck: "",
            fetchTruck: [

            ],
            jumlahTruck: 0,
            fetchSKU: [],
            max_trip: "",
            contract_rate: "",
            sku: "",
            driver: "",
            isLoading: false,
            active: this.showModal,
            forms: [],
            locale: [],
            return_date: [],
            delivery_date: [],
            equipment_name: [],
            fetchEquipmentName: [],
        };
    },
    methods: {
        resetForm() {
            this.periode = "";
            this.billableMethode = "";
            this.sku = "";
            this.max_trip = "";
            this.contract_rate = "";
            this.vehicle_no_array = [{ truck_no: 1, vehicle: '' }];
            this.fetchTruckVehicleNo = [];
        },

        // Rebuild 
        cekAlokasiDriver(ev) {
            this.forms.assign_driver = ev.nmk;
            this.forms.assign_name_driver = ev.driver_name;
        },

        loadDriver() {

            const baseURI =
                this.$settings.endPointMPR + `v1/mpr/lookup/drivers-new?nullPic=true&jenis_driver=${(this.data?.jenis_driver ? this.data.jenis_driver : "")}`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchDriver = response.data.datas.data;

            });


        },

        customLabel(ev) {
            return `${ev.nmk} – ${ev.driver_name}`
        },


        loadTruckVehicleNo() {
            this.fetchTruckVehicleNo = [];
            const baseURI = this.$settings.endPointCt + `master-truck/select`;
            return this.$http.get(baseURI).then((response) => {
                if (response.data && response.data.datas && response.data.datas.data) {
                    var vehicleNumbers = response.data.datas.data;
                    vehicleNumbers.forEach((row) => {
                        this.fetchTruckVehicleNo.push({ vehicle_no: row.vehicle_no });
                    });
                    console.log(this.fetchTruckVehicleNo);
                } else {
                    console.error('Data tidak valid atau kosong');
                }
            }).catch((error) => {
                console.error('Error fetching data:', error);
            });
        },

        onSearchChangeTruckVehicleNo(ev) {
            this.fetchTruckVehicleNo = [];
            const baseURI = this.$settings.endPointCt + `master-truck/select?vehicle_no=` + ev;
            return this.$http.get(baseURI).then((response) => {
                var vehicleNumbers = response.data.datas.data;

                vehicleNumbers.forEach((row) => {
                    // Akses vehicle_no langsung dari objek row
                    this.fetchTruckVehicleNo.push({ vehicle_no: row.vehicle_no });
                });

            }).catch((error) => {
                console.error('Error fetching data:', error);
            });
        },


        addRow() {
            this.vehicle_no_array.push({ truck_no: this.vehicle_no_array.length + 1, vehicle: '' });
        },
        removeRow(index) {
            this.vehicle_no_array.splice(index, 1);
        },

        asyncSearchDriver(ev) {
            this.fetchDriver = [];
            const baseURI =
                this.$settings.endPointMPR + `v1/mpr/lookup/drivers-new?nullPic=true&jenis_driver=${this.data.jenis_driver}&search=` + ev;
            return this.$http.get(baseURI).then((response) => {
                this.fetchDriver = response.data.datas.data;
            });
        },

        changeGetBil() {
            //this.fetchDriver = [];
            const baseURI =
                this.$settings.endPoint + `lumpsum-rental/get-bill-rate?billable_method=${this.billableMethode.tariff_name}&sku=${this.sku.sku_code}`;
            return this.$http.get(baseURI).then((response) => {
                var data = response.data.datas;
                this.max_trip = data.max_trip;
                this.contract_rate = data.contract_rate;
                console.log(data);
                this.changeVehicleHistory();
                this.changeVehicle();
            });
        },

        changeVehicleHistory() {
            //this.fetchDriver = [];

            const baseURI =
                this.$settings.endPoint + `lumpsum-rental/get-vehicle?rm_billable_rate_header_id=${this.data.rm_billable_rate_header_id}&billable_method=${this.billableMethode.tariff_name}&sku=${this.sku.sku_code}`;
            return this.$http.get(baseURI).then((response) => {
                //this.fetchTruckVehicleNo = [];
                var data = response.data.datas;
                this.vehicle_no_array = [];
                data.vehicle.forEach((row) => {
                    this.vehicle_no_array.push({
                        truck_no: this.vehicle_no_array.length + 1, vehicle: {
                            vehicle_no: row.vehicle_no
                        }
                    });

                });


            });
        },

        changeVehicle() {
            //this.fetchDriver = [];

            const baseURI =
                this.$settings.endPoint + `lumpsum-rental/get-master-truck?sku=${this.sku.sku_code}`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchTruckVehicleNo = [];
                var data = response.data.datas;

                data.forEach((row) => {
                    this.fetchTruckVehicleNo.push({ vehicle_no: row.vehicle_no });

                });


            });
        },


        submitData() {
            console.log();


            var updatedVehicleArray = this.vehicle_no_array.map((item) => {
                return {
                    truck_no: item.truck_no,
                    vehicle_no: item.vehicle.vehicle_no // Mengambil vehicle_no dari dalam objek vehicle
                };
            });


            var data = {
                "rm_billable_rate_header_id": this.data.rm_billable_rate_header_id,
                "company_id": this.data.company_id,
                "customer_name": this.data.customer_name,
                "customer_code": this.data.customer_code,
                "billable_method": this.billableMethode.tariff_name,
                "periode": moment(String(this.periode)).format("MM-YYYY"),
                "sku": this.sku.sku_code,
                "max_trip": this.max_trip,
                "contract_rate": this.contract_rate,
                "JumlahTruck": this.vehicle_no_array.length,
                "vehicle": updatedVehicleArray
            }

            console.log(data);

            this.isLoading = true;
            const baseURI = this.$settings.endPoint + "lumpsum-rental/list-lumpsum/create";
            this.$http
                .post(baseURI, data)
                .then((response) => {
                    this.isLoading = false;
                    if (response) {

                        this.$emit("closeModal");
                        this.loadSuccess("Success");
                    } else {

                        this.errors = response.data.errors;
                        this.resultError(response.data.errors);
                    }


                })
                .catch((error) => {
                    this.isloading = false;
                    if (error.response) {
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                            this.resultError(error.response.data.errors);

                        }
                    }

                });

        },

     
        loadBillabel() {
            const baseURI =
                this.$settings.endPoint + `rm-billable-tariff?customer_code=${this.data.customer_code}&status=ENABLED&sob=EXIST`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchBillabel = response.data.datas.data;

            });
        },

        asyncSearchBillabel(ev) {
            const baseURI =
                this.$settings.endPoint + `rm-billable-tariff?customer_code=${this.data.customer_code}&status=ENABLED&sob=EXIST&tariff_name=${ev}`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchBillabel = response.data.datas.data;

            });
        },


        asyncSearchSKU(ev) {
            const baseURI =
                this.$settings.endPoint + `sku?company_name=` + this.data.customer_name+'&sku_code='+ev;
            return this.$http.get(baseURI).then((response) => {
                this.fetchSKU = response.data.datas.data;

            });
        },

        loadSKU() {
            const baseURI =
                this.$settings.endPoint + `sku?company_name=` + this.data.customer_name;
            return this.$http.get(baseURI).then((response) => {
                this.fetchSKU = response.data.datas.data;

            });
        },

        submitToCt(row) {
            console.log(row);
            //this.fade(true);
            const baseURI = this.$settings.endPointCt + "master-truck/update-truck-statusupdate-truck-status-for-fppk"
                .post(baseURI, row)
                .then((response) => {
                    console.log(response)
                    this.loading();
                    if (response.data.status === 200) {
                        // this.updateStatus(row.fppk_id, 'Pengajuan')

                    } else {
                        this.errors = response.data.errors;
                        this.resultError(response.data.errors);
                    }
                })
                .catch((error) => {
                    this.loading();
                    if (error.response) {
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                            if (this.errors.message) {
                                this.error(this.errors.message);
                            } else {
                                this.resultError(error.response.data.errors);
                            }
                        } else if (error.response.status === 500) {
                            this.error(error.response.data.errors.message);
                        } else {
                            this.$router.push("/page-not-found");
                        }
                    }
                    //this.resetForm();
                });
        },


        resultError(data) {
            var html = "";
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    html += objectData[y] + "<br>";
                }
            }

            this.loadError(html);
        },

        loadError(pesan) {
            this.$swal({
                backdrop: true,
                title: "Warning",
                html: pesan,
                showConfirmButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then((result) => {
                if (result.value) {
                    this.isLoading = false;
                }
            })
        },



        loadSuccess(pesan) {
            this.$swal({
                backdrop: true,
                title: "Success",
                html: pesan,
                showConfirmButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then((result) => {
                if (result.value) {
                    this.isLoading = false;
                }
            })
        },


    },
    created: function () {
        //this.loadDriver();

    },
    mounted() {

        const formElement = this.$refs.formElement;
        if (formElement) {
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'readonly') {
                        const inputs = formElement.querySelectorAll('.multiselect__input');
                        inputs.forEach(input => {
                            input.removeAttribute('readonly');  // Hapus readonly setiap kali diubah
                        });
                    }
                });
            });

            const inputs = formElement.querySelectorAll('.multiselect__input');
            inputs.forEach(input => {
                observer.observe(input, { attributes: true });
            });
        }


        //tail(this.data);
    },
};
</script>

<style scoped>
.modal {
    background: rgba(0, 0, 0, 0.4);
}

.modal-content {
    background: #fff;
    border-radius: 0px;
    border: none;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    padding: 0px;
    width: 100%;
    height: 100%;
    margin-left: 0px !important;
}

.modal-dialog {
    max-width: 90vw;   /* lebar 90% layar */
    width: 90vw;
    margin: 5vh auto;  /* supaya ada jarak atas bawah */
}
</style>